module.exports = __webpack_public_path__ + "media/bg.f728cd64.mp4";